import { Link } from "react-router-dom";
import { games } from "@/mocks/games";

const guideBg =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20warm%20reading%20desk%20at%20night%20with%20glowing%20book%20and%20game%20icons%2C%20a%20lantern%20and%20open%20notebook%2C%20cozy%20guided%20mood%2C%20warm%20amber%20and%20cream%20palette%2C%20magazine%20art%2C%20no%20text&width=1600&height=700&seq=guide-banner-001&orientation=landscape";

export default function BeginnerTeaser() {
  const beginner = games.filter((g) => g.isBeginner);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-2xl">
        <img src={guideBg} alt="入门指南背景" className="absolute inset-0 h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/40"></div>
        <div className="relative grid w-full gap-8 p-8 md:p-12 lg:grid-cols-[1.2fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-compass-3-line"></i> 新手友好
            </span>
            <h2 className="mt-4 font-display text-2xl font-bold text-background-50 md:text-3xl">
              第一次玩，从这里开始
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-100/90">
              面对海量作品无从下手？我们整理了完整的入门指南：怎么选、怎么买、
              先玩哪几部、如何避雷，全部讲清楚。四部低门槛代表作带你轻松入坑。
            </p>
            <Link
              to="/guide"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-foreground-950 whitespace-nowrap transition-colors hover:bg-background-100"
            >
              查看入门指南 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {beginner.map((g) => (
              <Link
                key={g.id}
                to={`/review/${g.id}`}
                className="group flex items-center gap-3 rounded-xl border border-background-50/20 bg-background-950/40 p-3 backdrop-blur-sm transition-colors hover:border-primary-400"
              >
                <img src={g.cover} alt={`${g.title} 封面`} className="h-14 w-11 shrink-0 rounded-md object-cover object-top" />
                <div className="min-w-0">
                  <div className="truncate font-display text-sm font-bold text-background-50">{g.title}</div>
                  <div className="mt-0.5 text-xs text-primary-300">{g.score.toFixed(1)} 分 · 入门</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}